import Drawer from 'react-modern-drawer';
import { FormGroup, Input, Label } from 'reactstrap';
import DefaultButton from '../../../../../components/Buttons/Default';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const EMPTY_FILTERS = {
  bill_number: '',
  status: '',
  added_after: '',
  added_before: ''
};

function FiltersDrawer({ isOpen, toggle, applyFilters, filters = {} }) {
  const { t } = useTranslation();
  const [filtersData, setFiltersData] = useState({ ...EMPTY_FILTERS, ...filters });

  useEffect(() => {
    if (isOpen) {
      setFiltersData({ ...EMPTY_FILTERS, ...filters });
    }
  }, [isOpen]);

  const clearFilters = () => {
    setFiltersData(EMPTY_FILTERS);
    applyFilters({});
  };

  return (
    <Drawer
      open={isOpen}
      onClose={toggle}
      direction="right"
      size={400}
      enableOverlay={true}
      lockScroll={true}
      zIndex={9000}
      duration={200}
    >
      <div className="p-3 drawer-content">
        <h4 className="fw-bold">{t("common.filter")}</h4>

        <FormGroup>
          <Label>{t("purchases.billNumber")}</Label>
          <Input
            value={filtersData.bill_number}
            onChange={(e) => setFiltersData({ ...filtersData, bill_number: e.target.value })}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t("common.status")}</Label>
          <Input
            type="select"
            value={filtersData.status}
            onChange={(e) => setFiltersData({ ...filtersData, status: e.target.value })}
          >
            <option value="">{t("common.all")}</option>
            <option value="unpaid">{t("common.unpaid")}</option>
            <option value="partially_paid">{t("common.partiallyPaid")}</option>
            <option value="paid">{t("common.paid")}</option>
          </Input>
        </FormGroup>
        <hr />
        <FormGroup>
          <Label>{t("common.addedAfter")}</Label>
          <Input
            type="date"
            value={filtersData.added_after}
            onChange={(e) => setFiltersData({ ...filtersData, added_after: e.target.value })}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t("common.addedBefore")}</Label>
          <Input
            type="date"
            value={filtersData.added_before}
            onChange={(e) => setFiltersData({ ...filtersData, added_before: e.target.value })}
          />
        </FormGroup>

        <DefaultButton block onClick={() => applyFilters(filtersData)} style={{ marginBottom: '10px' }}>
          {t("common.filter")}
        </DefaultButton>

        <DefaultButton block onClick={clearFilters} color="light" outline>
          {t("common.cancel")}
        </DefaultButton>
      </div>
    </Drawer>
  );
}

export default FiltersDrawer;
